import gql from 'graphql-tag';

const GET_WINDOWS_FROM_LOCAL = gql`
    query getWindowsFromLocal ($input: GetWindowsFromLocalInput) {
        getWindowsFromLocal (input: $input) {
            message,
            status,
            data {
                carrier,
                carrierId,
                dates {
                    date,
                    deliveryWindows {
                        startWindowPreparation,
                        endWindowPreparation,
                        startWindowPromise,
                        endWindowPromise,
                        promise,
                        startWindow,
                        endWindow,
                        fullWindow,
                        label,
                        value,
                        availableCapacity
                    }
                }
                deliveryWindows {
                    startWindowPreparation,
                    endWindowPreparation,
                    startWindowPromise,
                    endWindowPromise,
                    promise,
                    startWindow,
                    endWindow,
                    fullWindow,
                    label,
                    value,
                    availableCapacity
                }
            }
        }
    }
`;

export default GET_WINDOWS_FROM_LOCAL;
